// Константы проектов wordstat
export const ProjectsConstants = {
    INITIAL_WORD: 1,
    ASSOCIATIONS_WORD: 2,
    ADDITIONS_WORD: 3,
    // регулярка валидатора по ключевым фразам
    VALIDATOR_REGEXP: /^[abcdefghijklmonpqrstuvwxyzABCDEFGHIJKLMONPQRSTUVWXYZабвгдеёжзийклмнопрстуфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯЄЇєїҐґЎў'ІіҰҒғӨҢҚҺҮұөңқһүҖҲҳҗӘәÄäßẞğĞşŞçÇıİ̇âÂîÎûÛéüÜöÖʻҲҳʼÁáÀàẢảÃãẠạĂăẮắẰằẲẳẴẵẶặẤấẦầẨẩẪẫẬậĐđÉÈèẺẻẼẽẸẹÊêẾếỀềỂểỄễỆệÍíÌìỈỉĨĩỊịÓóÒòỎỏÕõỌọÔôỐốỒồỔổỖỗỘộƠơỚớỜờỞởỠỡỢợÚúÙùỦủŨũỤụƯưỨứỪừỬửỮữỰựÝýỲỳỶỷỸỹỴỵáéíñóúÁÉÍÑÓÚáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽąćęłńóśźżĄĆĘŁŃÓŚŹŻ0123456789. ()]*$/,

    // тип парсинга "Сбор фразы"
    PARSING_TYPE_PHRASES: 0,
    // тип парсинга "Сбор частотности"
    PARSING_TYPE_WS: 1,

    // источник WS
    SOURCE_WS: 0,
    // источник DIRECT
    SOURCE_DIRECT: 1,

    // период, неделя
    PERIOD_WEEK: 0,
    // период, месяц
    PERIOD_MONTH: 1,
    // период, квартал
    PERIOD_QUARTER: 2,
    // период, год
    PERIOD_YEAR: 3,

    /**
     * тип периода при выборе месяца
     */
    PERIOD_MONTH_TYPE_30_DAYS: 0,
    PERIOD_MONTH_TYPE_JANUARY: 1,
    PERIOD_MONTH_TYPE_FEBRUARY: 2,
    PERIOD_MONTH_TYPE_MARCH: 3,
    PERIOD_MONTH_TYPE_APRIL: 4,
    PERIOD_MONTH_TYPE_MAY: 5,
    PERIOD_MONTH_TYPE_JUNE: 6,
    PERIOD_MONTH_TYPE_JULY: 7,
    PERIOD_MONTH_TYPE_AUGUST: 8,
    PERIOD_MONTH_TYPE_SEPTEMBER: 9,
    PERIOD_MONTH_TYPE_OCTOBER: 10,
    PERIOD_MONTH_TYPE_NOVEMBER: 11,
    PERIOD_MONTH_TYPE_DECEMBER: 12,

    /**
     * Тип снятия частотности
     */
    FREQUENCY_TYPE_WS: 0,
    FREQUENCY_TYPE_QWSK: 3,
    FREQUENCY_TYPE_WSK: 1,
    FREQUENCY_TYPE_SWSK: 2,

    /**
     * Устройства WS
     */
    WS_DEVICES_DESKTOP: 0,
    WS_DEVICES_TABLET: 1,
    WS_DEVICES_MOBILE: 2,

    /**
     * Устройства Direct
     */
    DIRECT_DEVICES_ALL: 0,
    DIRECT_DEVICES_MOBILE: 1,
}

// добавляем ссылки на дефолтные значения
Object.assign(ProjectsConstants, {
    PARSING_TYPE_DEFAULT: ProjectsConstants.PARSING_TYPE_WS,
    SOURCE_DEFAULT: ProjectsConstants.SOURCE_DIRECT,
    PERIOD_DEFAULT: ProjectsConstants.PERIOD_MONTH,
    PERIOD_MONTH_TYPE_DEFAULT: ProjectsConstants.PERIOD_MONTH_TYPE_30_DAYS,
    DIRECT_DEVICES_DEFAULT: ProjectsConstants.DIRECT_DEVICES_ALL,
});
